import React, { Fragment } from "react";
import "./styles.css";

const RegistrationLayout = (props) => {
  const {
    className,
    viewHeight = false,
    blurSpots = false,
    fullWidth = false,
  } = props;
  return (
    <Fragment>
      <div
        className={`${
          blurSpots ? "blur-spots template-layout" : "template-layout"
        }`}
      >
        <div
          className={`container ${
            fullWidth ? "jumbotron-container" : "fluid-container"
          } ${className}__container ${viewHeight ? "view-height" : ""}`}
        >
          <div className={`row ${className}__row`}>{props.children}</div>
        </div>
      </div>
    </Fragment>
  );
};
export default RegistrationLayout;
